<template>
  <div>
    <!-- %%%%%%%%%%%%%%%%%%%% SIGNATURE SECTION %%%%%%%%%%%%%%%%%%% -->
    <table v-if="showSignatureSection" class="signature-section">
      <tr>
        <th class="left-signature-text">
          <p style="margin: 0px">{{ $t('Accountant') }}</p>
          <p style="margin: 0px">{{ accountantName }}</p>
        </th>
        <th class="right-signature-text">
          <p style="margin: 0px">{{ payerOrRecipient }}</p>
          <p style="margin: 0px">{{ payerRecipientName }}</p>
        </th>
      </tr>
    </table>

    <table class="invoice-footer">
      <tr>
        <td style="width: 500px; height: 30px">
          <strong class="footer-titles">Address:</strong>
          <span style="text-transform: capitalize">{{ footerData.outlet_address }}</span>
        </td>
        <td style="width: 300px; text-align: right;">
          <strong class="footer-titles">Email:</strong>
          <span>{{ footerData.outlet_email }}</span>
        </td>
      </tr>
      <tr>
        <td style="width: 500px; height: 30px">
          <strong class="footer-titles">Phone:</strong>
          <span style="text-transform: capitalize">{{ footerData.outlet_phone }}</span>
        </td>
        <td style="width: 300px; text-align: right;">
          <strong class="footer-titles">Website:</strong>
          <span>{{ footerData.outlet_website }}</span>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    showSignatureSection: { type: Boolean, required: true },
    accountantName: { type: String, required: false },
    payerRecipientName: { type: String, required: false },
    payerOrRecipient: { type: String, required: false }
  },

  computed: {
    ...mapGetters({
      authUserData: 'auth/getAuthUserData'
    })
  },

  data() {
    return {
      footerData: {
        outlet_email: '',
        outlet_phone: '',
        outlet_address: '',
        outlet_website: ''
      }
    }
  },

  watch: {
    authUserData: {
      immediate: true,
      handler() {
        if (this.authUserData.constructor === Object && Object.keys(this.authUserData).length !== 0) {
          this.footerData.outlet_email = this.authUserData.outlet_info.outlet_email
          this.footerData.outlet_phone = this.authUserData.outlet_info.outlet_phone
          this.footerData.outlet_address = this.authUserData.outlet_info.outlet_address
          this.footerData.outlet_website = this.authUserData.outlet_info.outlet_website
        }
      }
    }
  }
}
</script>

<style>
.invoice-footer {
  width: 100%;
  position: fixed;
  border: 2px solid #172653;
  bottom: 0;
  left: 0;
  padding: 5px;
  border-radius: 2px;
}
.footer-titles {
  color: #17124e;
  -webkit-print-color-adjust: exact;
}
</style>
